export const charities = new Map([
    ["thirdwavevolunteers", {
        image: "/images/charities/third_wave_volunteers.png",
        url: "https://angelprotocol.io/app/charity/terra10qeaeukmyy2kqw5f2fvut5pmm9gaqvnrqtsk22",
        backgroundColor: "#121212",
        disabled: false,
    }],
    ["core", {
        image: "/images/charities/core.png",
        url: "https://angelprotocol.io/app/charity/terra15w8pfr48vxzparmf8qvwsxtlkzkf0uvawzxaeu",
        backgroundColor: "#efeff4",
        disabled: false
    }],
    ["novaukraine", {
        image: "/images/charities/nova_ukraine.png",
        url: "https://angelprotocol.io/app/charity/terra1c95a3sjpt3jat2azphjt2sk8xqvcwj0uexjp8d",
        backgroundColor: "#ffffff",
        disabled: false,
    }],
])